import { Dispatch, Fragment, SetStateAction } from 'react'
import { AnyObject, Form } from 'react-final-form'
import { FontAwesomeSvgIcon as FontAwesomeIcon } from 'react-fontawesome-svg-icon'

import { faArrowRight } from '@fortawesome/pro-light-svg-icons/faArrowRight'
import { faSpinnerThird } from '@fortawesome/pro-light-svg-icons/faSpinnerThird'

import { FEATURE_FLAGS } from '@infura/packages.common/constants'
import Notification from '@infura/packages.components/Notification'
import { Button } from '@infura/packages.ui/Button'
import { Card } from '@infura/packages.ui/Card'

import FeatureToggle from 'components/FeatureToggle'
import FieldInput from 'components/FieldInput'

import { Infura } from 'lib/types/infuraTypes'

interface FormRefreshProps {
  onSubmit: ({ mfaVerificationCode }) => Promise<boolean | AnyObject>
  setLoginStep: Dispatch<SetStateAction<Infura.AUTH_LOGIN_STEP>>
}

export default function FormRefresh({ onSubmit, setLoginStep }: Readonly<FormRefreshProps>) {
  return (
    <section className='flex h-full w-full flex-col items-center justify-start lg:justify-center'>
      <div className='w-full max-w-2xl px-6'>
        <Card className='w-full bg-background-default pb-6 !shadow-none'>
          <h1 className='font-body mb-2 text-4xl font-bold'>Enter your Auth Token</h1>
          <Form
            onSubmit={onSubmit}
            render={({ handleSubmit, submitError, submitting }) => (
              <Fragment>
                {submitError ? (
                  <Notification className='mb-2' color='alert' size='sm' variant='outlined'>
                    <span className='w-full text-center'>{submitError}</span>
                  </Notification>
                ) : null}
                <form onSubmit={handleSubmit}>
                  <FieldInput
                    autoComplete='off'
                    className='mb-7 !h-auto !px-6 !py-5 text-lg 2xl:text-xl'
                    data-testid='mfa-verify'
                    inputMode='numeric'
                    label={<span className='mb-2'>Two Factor Auth Token</span>}
                    name='mfaVerificationCode'
                    pattern='[0-9 ]*'
                    placeholder='XXX XXX'
                    required
                    type='text'
                  />

                  <div className='mb-8 flex flex-col items-center gap-6 2xl:flex-row'>
                    <Button
                      data-testid='mfa-verify'
                      disabled={submitting}
                      fullWidth
                      onClick={handleSubmit}
                      type='button'
                    >
                      {submitting ? <FontAwesomeIcon className='fa-fw fa-spin' icon={faSpinnerThird} /> : 'Submit'}
                    </Button>
                  </div>
                </form>
              </Fragment>
            )}
          />

          <FeatureToggle flag={FEATURE_FLAGS.UPDATES_2FA}>
            <div className='border-t border-border-muted pb-2 pt-6 text-center lg:text-left'>
              <p className='mb-0  2xl:text-xl'>Can’t access your Authenticator App?</p>
              <p className='mb-0  2xl:text-xl'>
                <span>Sign in with your </span>
                <a className='2xl:text-xl' onClick={() => setLoginStep(Infura.AUTH_LOGIN_STEP.MFA_RESET)}>
                  Backup Code
                </a>
                <span> or </span>
                <a className='2xl:text-xl' onClick={() => setLoginStep(Infura.AUTH_LOGIN_STEP.MFA_RECOVER)}>
                  <span>Recover your Account </span>
                  <FontAwesomeIcon className='ml-1' icon={faArrowRight} />
                </a>
              </p>
            </div>
          </FeatureToggle>
        </Card>
      </div>
    </section>
  )
}
